import { Avatar, AvatarPlaceholder } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  Avatar,
  AvatarPlaceholder,
  React
};